import axios from 'axios'//引入axios
import store from '../store'
import { notification } from 'ant-design-vue'

var loginUrl=store.state.axiosUrl;
/*是否正在刷新的标志*/
window.isRefreshing = false
/*存储请求的数组*/
let refreshSubscribers = []
 
/*将所有的请求都push到数组中,其实数组是[function(token){}, function(token){},...]*/
function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}
/*数组中的请求得到新的token之后自执行，用新的token去请求数据*/
function onRrefreshed(token) {
  refreshSubscribers.map(cb => cb(token));
}
// 请求发起前操作
axios.interceptors.request.use(config => {
    if(typeof config.headers.Authorization!='undefined')
    {
        var timeStart=localStorage.getItem('tokenTime')?localStorage.getItem('tokenTime'):0;
        var date=new Date();
        var timeEnd=date.getTime();
        var tokenTerm=localStorage.getItem('tokenTerm')?localStorage.getItem('tokenTerm'):0;
        /*判断token是否即将过期*/
        /*  `/auth/current`是刷新token的接口，只有当token将要过期且不是请求刷新token的接口才会进入*/
        if((timeEnd-timeStart)< tokenTerm && (timeEnd-timeStart) > (tokenTerm-30000) && config.url !== loginUrl+'/sys/refresh_token?refresh_token='+store.state.login.refresh_token) {
            /*首先所有的请求来了，我们要先判断当前是否正在刷新，如果不是，将刷新的标志置为true并请求刷新token；如果是，将请求存储到数组中*/
            if(!window.isRefreshing) {
                window.isRefreshing = true
                axios.post(loginUrl+'/sys/refresh_token?refresh_token='+store.state.login.refresh_token).then(res => {
                    //refreshtoken为获取token的方法，包括window.isRefreshing = false
                    /*将刷新的token替代老的token*/
                    config.headers.Authorization = 'Bearer ' + res.data.access_token 
                    /*更新内存的auth*/
                    store.state.access_token=res.data.access_token;
                    store.state.login=res.data;
                    localStorage.setItem("access_token", res.data.access_token);
                    var date=new Date();
                    var time=date.getTime();
                    localStorage.setItem("tokenTime",time);
                    /*执行数组里的请求，重新发起被挂起的请求*/
                    onRrefreshed(res.data.access_token)
                }).catch(()=>{
                    localStorage.setItem("access_token", '');
                    localStorage.setItem("tokenTime",0);
                    location.reload()
                })
                window.isRefreshing = false
            }
            let retry = new Promise((resolve,) => {
                /*(token) => {...}这个函数就是cb*/
                subscribeTokenRefresh((token) => {
                     config.headers.Authorization = 'Bearer ' + token
                     /*将请求挂起*/
                     resolve(config)
                })
            })
            return retry
        }
        else
        {
            return config;
        }
    }
    else
    {
        return config;
    }
});
// 请求响应后
axios.interceptors.response.use(response => {
    // 在发送请求之前做些什么
    // console.log('Request was sent');
    return response;
}, function (error) {
    // 请求错误信息处理
    switch (error.response.status){
        case 400:
            console.log("错误请求");
            break;
        case 401:
            console.log("未授权,请重新登录");
            localStorage.removeItem('access_token');
            if(error.response.data.error=='invalid_token')
            {
                // alert("请重新登录");
                notification['warning']({
                    message: '提示',
                    description:'登录已过期，请重新登录!',
                });
                setTimeout(function(){
                    location.reload()
                },1000);
            
                
            }
            break;
        case 403:
            notification['warning']({
                message: '提示',
                description:'没有权限，不允许访问!',
            });
            console.log("拒绝访问");
            break;
        case 404:
            console.log("请求错误,未找到该资源");
            break;
        case 405:
            console.log("请求方法未允许");
            break;
        case 408:
            console.log("请求超时");
            break;
        case 500:
            notification['error']({
                message: '服务器异常，请联系管理员！',
                description:error.response.data.error_description,
            });
            console.log("服务器错误");
            break;
        case 501:
            console.log("网络未实现");
        break;
        case 502:
            console.log("网络错误");
            break;
        case 503:
            console.log("服务不可用");
            break;
        case 504:
            console.log("网络超时");
            break;
        case 505:
            console.log("HTTP版本不支持该请求");
            break;
        default:
            break;
    }
    return Promise.reject(error.response.data)
});
export default {//导出方法
    /**
    * 登录请求方法*
    * @param {String} url [请求的url地址]
    * @param {String} type [请求 的类型]
    * @param {Object} params [请求时携带的参数]
    * */
   axiosData(url,type,parameter,headers){
        return new Promise((resolve,reject) => {
            var header=typeof headers=='undefined'?{}:headers;
            const params = type === 'get' ? { url:loginUrl+url, method: type, params:parameter } : { url:loginUrl+url, method: type, data:parameter }
            if(typeof(store.state.access_token)!='undefined'&&store.state.access_token!='')
            {
                header.Authorization='Bearer '+store.state.access_token
            }
            axios(Object.assign(params,{headers:header})).then((res)=>{
                resolve(res);
            }).catch((err)=>{
                reject(err);
            })
        })
    },

     /**
    * 测试本地接口，请求方法*
    * @param {String} url [请求的url地址]
    * @param {String} type [请求 的类型]
    * @param {Object} params [请求时携带的参数]
    * */
    // axiosCeshi(url,type,params={}){
    //     return new Promise((resolve,reject) => {
    //         var headers={};
    //         if(typeof(store.state.login.access_token)!='undefined')
    //         {
    //             headers={'Authorization':'Bearer '+store.state.login.access_token}
    //         }
    //         axios({
    //             url:url,
    //             method: type,
    //             data:params,
    //             headers:headers
    //         }).then((res)=>{
    //             resolve(res);
    //         }).catch((err)=>{
    //             reject(err);
    //         })
    //     })
    // },
}

    /**

    *axios 自带请求超时属性设置

    *timeout: 4000, // 4 seconds timeout 超时

    **/
